import { api } from 'api'
import orm from 'models/orm'
import { i18nReducer } from 'react-redux-i18n'
import { RouteComponentProps } from 'react-router-dom'
import { routerReducer } from 'react-router-redux'
import { combineReducers } from 'redux'
import { createReducer } from 'redux-orm'
import { reducer as aiConversations } from 'slices/aiConversations'
import { reducer as aiSegmentBuilder } from 'slices/aiSegmentBuilder'
import { pickerReducer as picker } from 'slices/aiSegmentBuilder/picker'
import { reducer as appLandingPageTheme } from 'slices/appLandingPageTheme'
import { reducer as appNavigation } from 'slices/Cms/Content/AppNavigation'
import { reducer as postOrderFeedback } from 'slices/Cms/Settings/PostOrderFeedback'
import { reducer as scannableCodes } from 'slices/Cms/Settings/ScannableCodes'
import { reducer as giftCards } from 'slices/giftCards'
import { reducer as legalDocsBlock } from 'slices/legalDocsBlock'
import { reducer as orderFeedbackCollection } from 'slices/orderFeedbackCollection'
import { reducer as orderFeedbackGuestExperience } from 'slices/orderFeedbackGuestExperience'
import { reducer as orderFeedbackReplyAddress } from 'slices/orderFeedbackReplyAddress'
import { reducer as orderingErrorMessages } from 'slices/orderingErrorMessages'
import { reducer as recoveryAiActivity } from 'slices/recoveryAiActivity'
import { reducer as richTextEditor } from 'slices/richTextEditor'
import { reducer as userLists } from 'slices/userLists'
import auth from './auth'
import flash from './flash'
import redirect from './redirect'

export default combineReducers({
  routing: routerReducer as () => RouteComponentProps,
  flash,
  auth,
  aiConversations,
  aiSegmentBuilder,
  picker,
  appLandingPageTheme,
  appNavigation,
  postOrderFeedback,
  scannableCodes,
  giftCards,
  legalDocsBlock,
  userLists,
  orderingErrorMessages,
  orderFeedbackCollection,
  orderFeedbackReplyAddress,
  orderFeedbackGuestExperience,
  recoveryAiActivity,
  richTextEditor,
  orm: createReducer(orm),
  i18n: i18nReducer,
  redirect,
  api: api.reducer,
})
